import { createAction } from 'modules/redux-store';

export const loginAction = {
  success: () => createAction('LOGIN_SUCCESS'),
  error: () => createAction('LOGIN_ERROR'),
};
